define([
	"dojo/_base/declare",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale/Renderer"
], function(declare,BusinessObject,Renderer) {

	return declare(Renderer, {
		_getNodeType: function(/*Context*/ctx) {
			return BusinessObject.getRootType(ctx.getNode());
		}
	});
});